// @ts-nocheck
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import getFieldDefinitionsDefaultValues from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/getFieldDefinitionsDefaultValues";
import getValuesPerBreakpoint from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/getValuesPerBreakpoint";

/**
 * A function that generates FieldDefinitions with the required fields to make the ResponsiveFields work
 * @param childFieldDefinitions - The ChildFieldDefinition to generate the ResponsiveFields
 * @returns - A set of FieldDefinition that handles the reponsive flow
 */
export const buildResponsiveFields = (childFieldDefinitions: ChildFieldDefinition[]): Toolkit.FieldDefinition[] => {
    const useResponsiveOptionsField: Toolkit.FieldDefinition = {
        fieldType: "General",
        name: "useResponsiveOptions",
        editorTemplate: "CheckboxField",
        defaultValue: false,
    };

    const copyDataToResponsiveField: Toolkit.FieldDefinition = {
        name: "copy",
        displayName: "Copy Basic Options To Responsive Options",
        editorTemplate: "CopyDataToResponsiveField",
        defaultValue: true,
        fieldType: "General",
        isVisible: item => item.fields.useResponsiveOptions,
        onClick: handleCopyToResponsive => {
            handleCopyToResponsive(responsiveRows.name, [
                useResponsiveOptionsField.name,
                responsiveRows.name,
                copyDataToResponsiveField.name,
            ]);
        },
    };

    const responsiveRows: Toolkit.FieldDefinition = {
        name: "responsive",
        editorTemplate: "ListField",
        getDisplay: (item: HasFields) => {
            const firstFieldKey = Object.keys(item.fields)[0];
            return item.fields[firstFieldKey];
        },
        defaultValue: getValuesPerBreakpoint(getFieldDefinitionsDefaultValues(childFieldDefinitions)),
        fieldType: "Translatable",
        hideAdd: true,
        hideDelete: true,
        isVisible: item => item.fields.useResponsiveOptions,
        fieldDefinitions: [...childFieldDefinitions],
    };

    return [useResponsiveOptionsField, copyDataToResponsiveField, responsiveRows];
};
